import React from 'react'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

interface CustomProps {
  className?: string
  children: JSX.Element | JSX.Element[]
  axios: 'x' | 'y'
  height?: string
  width?: string
  verticalShadow?: boolean
  insidePadding?: number
}

type Props = CustomProps & React.HTMLProps<HTMLDivElement>

export const BaseScrollStyle = styled.div`
  scroll-behavior: smooth;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${GLOBAL_COLORS.tidalBlue};
    border-radius: 3px;
  }
  /* Scroll background */
  &::-webkit-scrollbar-track-piece {
    background-color: ${GLOBAL_COLORS.tidalBlue01};
    width: 4px;
    border-radius: 2px;
  }
`

const XScroll = styled.div<{ width: string; padding: number }>`
  overflow-x: auto;
  width: ${({ width }) => width};
  margin-bottom: 10px;
  padding: ${({ padding }) => `${padding}px ${padding}px ${padding + 20}px ${padding}px`};
  /* Scroll */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${GLOBAL_COLORS.tidalBlue};
    border-radius: 3px;
  }
  /* Scroll background */
  &::-webkit-scrollbar-track-piece {
    background-color: ${GLOBAL_COLORS.tidalBlue01};
    height: 4px;
    border-radius: 2px;
  }
`

const YScroll = styled.div<{ height: string; padding: number }>`
  height: ${({ height }) => height};
  padding: ${({ padding }) => `${padding}px ${padding}px ${padding}px ${padding}px`};
  /* Scroll */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${GLOBAL_COLORS.tidalBlue};
    border-radius: 3px;
  }
  /* Scroll background */
  &::-webkit-scrollbar-track-piece {
    background-color: ${GLOBAL_COLORS.tidalBlue01};
    width: 4px;
    border-radius: 2px;
  }
`
const TopShadow = styled.div`
  width: 100%;
  height: 20px;
  background: linear-gradient(
    to bottom,
    ${GLOBAL_COLORS.seashellWhite} 0 30%,
    ${GLOBAL_COLORS.transparent}
  );
  position: sticky;
  top: 0px;
`

const BottomShadow = styled.div`
  width: 100%;
  height: 20px;
  background: linear-gradient(
    to top,
    ${GLOBAL_COLORS.seashellWhite} 0 30%,
    ${GLOBAL_COLORS.transparent}
  );
  position: sticky;
  bottom: -2px;
`
export const Scroll: React.FC<Props> = ({
  className,
  children,
  verticalShadow = false,
  insidePadding = 0,
  axios,
  height = 'auto',
  width = 'auto',
}) => (
  <>
    {axios === 'x' ? (
      <XScroll className={className} width={width} padding={insidePadding}>
        {children}
      </XScroll>
    ) : (
      <YScroll className={className} height={height} padding={insidePadding}>
        {verticalShadow && <TopShadow />}
        {children}
        {verticalShadow && <BottomShadow />}
      </YScroll>
    )}
  </>
)
